export const getCookie = (name: string) => {
    const cookie = global?.document?.cookie?.split?.('; ').find?.((row: any) => row?.startsWith?.(name));
    return cookie?.split?.('=')?.[1] || '';
};
